import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=0aecaa6e&scoped=true&lang=pug&"
import script from "./RoleList.vue?vue&type=script&lang=ts&"
export * from "./RoleList.vue?vue&type=script&lang=ts&"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=0aecaa6e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aecaa6e",
  null
  
)

export default component.exports